/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How is infeed conveyor oriented in relation to robot
 */
export type ConveyorConfigurationEnum = 'LEFT' | 'CENTER_LEFT' | 'CENTER_RIGHT' | 'RIGHT';

export const ConveyorConfigurationEnum = {
    LEFT: 'LEFT' as ConveyorConfigurationEnum,
    CENTER_LEFT: 'CENTER_LEFT' as ConveyorConfigurationEnum,
    CENTER_RIGHT: 'CENTER_RIGHT' as ConveyorConfigurationEnum,
    RIGHT: 'RIGHT' as ConveyorConfigurationEnum
};

